import { Tabs, Tab, Box, Typography, List } from "@mui/material";
import { styled } from "@mui/system";

export const StyledMiniTabs = styled(Tabs)(({ theme }) => ({
  width: "100%",
  minHeight: "35px",
  "& .MuiTabs-indicator": {
    backgroundColor: "#175cd3",
  },
}));

export const StyledMiniTab = styled(Tab)(({ theme }) => ({
  padding: "0px 6px 0px 6px",
  height: "35px",
  minHeight: "35px",
  transition: "background-color 0.2s ease, color 0.2s ease",
  cursor: "pointer",
  color: "#1b1c1d",
  fontWeight: "normal",
  "&:not(.Mui-selected):hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  "&.Mui-selected": {
    color: "#175cd3",
    fontWeight: "600",
    "& .MuiBox-root": {
      color: "#175cd3 !important",
    },
  },
  "&.disabled": {
    cursor: "not-allowed",
    color: "rgba(150, 150, 150, 0.7)",
    pointerEvents: "none",
  },
}));

export const StyledPlainMiniTabs = styled(Tabs)(({ theme }) => ({
  width: "100%",
  minHeight: "35px",
  "& .MuiTabs-indicator": {
    backgroundColor: "#175cd3",
  },
}));

export const StyledPlainMiniTab = styled(Tab)(({ theme }) => ({
  padding: "0px 6px 0px 6px",
  height: "35px",
  minHeight: "35px",
  transition: "background-color 0.2s ease, color 0.2s ease",
  cursor: "pointer",
  color: "#1b1c1d",
  fontWeight: "normal",
  "&:not(.Mui-selected):hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  "&.Mui-selected": {
    color: "#175cd3",
    fontWeight: "600",
    "& .MuiBox-root": {
      color: "#175cd3 !important",
    },
  },
  "&.disabled": {
    cursor: "not-allowed",
    color: "rgba(150, 150, 150, 0.7)",
    pointerEvents: "none",
  },
}));

export const ContentAreaBox = styled(Box)(({ theme }) => ({
  padding: "20px 24px",
}));

export const VasSubHeader = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  marginBottom: "10px",
  fontWeight: 600,
}));

export const FieldTitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
}));

export const PreviewSectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  fontWeight: 500,
}));

export const PreviewSectionSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  fontWeight: 600,
  marginBottom: "1.2rem",
  color: "#6e7e8e"
}));

export const PreviewFieldArea = styled(Typography)(({ theme }) => ({
  marginBottom: "1.2rem"
}));

export const PreviewDocumentArea = styled(Typography)(({ theme }) => ({
  padding: "0.6rem 0 1.2rem 0"
}));

export const PreviewFieldHeader = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: "0.2rem"
}));

export const PreviewFieldText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "normal",
  marginBottom: "0.5rem"
}));

// Layout wrappers, not text: they hold divs, checkboxes and other Typography,
// so rendering them as <p> nests paragraphs and breaks hydration. body1 is kept
// so the swap to a div does not change how the text inside renders.
export const PriceListHeaderTitleSection = styled(Box)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: 600,
  margin: "8px",
}));

export const PriceListHeaderArea = styled(Box)(({ theme }) => ({
  ...theme.typography.body1,
  backgroundColor: "#f8f8f8",
  border: "1px solid #eeeeee"
}));

export default VasSubHeader;
